import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { SonaAuthApiFacade } from '@sona/angular-auth-api';

/**
 * Redirects to `/onboarding` when the current signed-in user has not seen the onboarding yet.
 * Allows navigation otherwise.
 */
export const hasSeenOnboardingPage: CanActivateFn = async (
    route: ActivatedRouteSnapshot
) => {
    const authFacade = inject(SonaAuthApiFacade);
    const user = authFacade.user();

    const userId = user?.id;

    if (!userId) {
        return true;
    }

    // Check in Supabase user_metadata (fallback: app_metadata) whether onboarding has already been seen
    const onboardingSeenAt = (user.user_metadata?.['onboardingSeenAt'] ?? user.app_metadata?.['onboardingSeenAt']) as string | undefined;

    if (onboardingSeenAt) {
        return true;
    }

    return createUrlTreeFromSnapshot(route, ['/onboarding']);
};
